'use client'
import {
  SectionTagFilter_default
} from "./chunk-XEEAPD2W.mjs";
import {
  CarouselTitle_default,
  CarouselWithLink_default
} from "./chunk-LVDZESI2.mjs";
import {
  CollapsableText_default
} from "./chunk-MAJWJHOB.mjs";
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulButton_default
} from "./chunk-K3ITZBKW.mjs";
import {
  ContentfulImage_default,
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";
import {
  useSectionTagFilter
} from "./chunk-ISPH2TSR.mjs";
import {
  parseSectionItem
} from "./chunk-DJNQ4XY4.mjs";
import {
  useSections
} from "./chunk-VSTAKFRX.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-UYSR6ZT4.mjs";

// src/components/cards/Announcement.tsx
import { useEffect, useRef } from "react";
import { Button, ResponsiveModal, Typography } from "@wbk/ui";
import { createCookie, readCookie } from "@wbk/utils";
import { Link, useTranslation } from "@wbk/config";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AnnouncementSection = ({ section }) => {
  var _a;
  const card = section.contentCollection.items[0];
  const { t } = useTranslation(["contentful_common"]);
  const modalRef = useRef(void 0);
  useEffect(() => {
    var _a2;
    if (!(card == null ? void 0 : card.expiresAt) || new Date(card == null ? void 0 : card.expiresAt).getTime() > (/* @__PURE__ */ new Date()).getTime()) {
      const isSeen = !!readCookie(`announcement_${card.id}`.trim());
      if (!isSeen) {
        const frequency = card.frequency || 24;
        (_a2 = modalRef.current) == null ? void 0 : _a2.open();
        createCookie({
          name: `announcement_${card.id}`.trim(),
          value: "true",
          expiration: frequency / 24
        });
      }
    }
  }, [card]);
  if (!card) return null;
  const isLink = !!card.href && card.href !== "#";
  const isExternal = isLink && ((_a = card.href) == null ? void 0 : _a.startsWith("http"));
  const linkAction = isLink ? {
    as: Link,
    to: card.href || "#",
    target: isExternal ? "_blank" : void 0
  } : {};
  return /* @__PURE__ */ jsx(
    ResponsiveModal,
    {
      type: "modal",
      ignoreHistory: true,
      bodyClassName: "p-0",
      size: "2xl",
      title: false,
      ref: modalRef,
      cancel: false,
      action: false,
      body: ({ close }) => {
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          card.image && /* @__PURE__ */ jsx(
            Button,
            {
              as: Link,
              to: card.href,
              className: "w-full p-0",
              shape: "text",
              theme: "transparent",
              children: /* @__PURE__ */ jsx(ContentfulMedia_default, { media: card.image, className: "w-full" })
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "space-y-4 p-6", children: [
            /* @__PURE__ */ jsx(Typography, { variant: "heading-M", children: card.title }),
            card.subtitle && /* @__PURE__ */ jsx(Typography, { color: "text-secondary", children: card.subtitle }),
            card.buttonLabel && /* @__PURE__ */ jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ jsx(Button, __spreadProps(__spreadValues({}, linkAction), { onClick: close, className: "w-full md:w-auto", children: card.buttonLabel || t("contentful_common:close") })) })
          ] })
        ] });
      }
    }
  );
};
var Announcement_default = AnnouncementSection;

// src/components/cards/BenefitsTable.tsx
import { twMerge } from "tailwind-merge";
import { Typography as Typography2 } from "@wbk/ui";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var BenefitsTable = ({ section }) => {
  var _a;
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length)) return null;
  const [headerCard, ...packageCards] = cards;
  const features = ((_a = headerCard == null ? void 0 : headerCard.cmsTagsCollection) == null ? void 0 : _a.items) || [];
  return /* @__PURE__ */ jsx2(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_table_${section.id}`,
      children: /* @__PURE__ */ jsxs2("div", { className: "flex flex-col gap-6 md:flex-row md:items-center md:gap-10", children: [
        section.title && /* @__PURE__ */ jsxs2("div", { className: "shrink-0 space-y-1 md:max-w-xs", children: [
          /* @__PURE__ */ jsx2(Typography2, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx2(Typography2, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx2("div", { className: "w-full overflow-x-auto", children: /* @__PURE__ */ jsxs2(
          "div",
          {
            className: "grid gap-x-1",
            style: {
              gridTemplateColumns: `minmax(12rem, auto) repeat(${packageCards.length}, minmax(8rem, 1fr))`
            },
            children: [
              /* @__PURE__ */ jsxs2("div", { className: "border-text-tertiary/10 flex flex-col gap-1 rounded-t-md border border-b-0 bg-white/5 p-2 sm:p-4", children: [
                /* @__PURE__ */ jsx2(
                  Typography2,
                  {
                    variant: "label-M",
                    color: "action",
                    title: headerCard.title,
                    style: headerCard.color ? { color: headerCard.color } : void 0,
                    children: headerCard.title
                  }
                ),
                /* @__PURE__ */ jsx2(Typography2, { variant: "body-S", color: "text-secondary", children: headerCard.subtitle })
              ] }),
              packageCards.map((pkg) => /* @__PURE__ */ jsxs2(
                "div",
                {
                  className: "border-text-tertiary/10 flex flex-col items-center gap-1 rounded-t-md border border-b-0 bg-white/5 p-2 text-center sm:p-4",
                  style: pkg.color ? {
                    borderColor: pkg.color,
                    borderBottom: "none",
                    borderWidth: "2px"
                  } : void 0,
                  children: [
                    /* @__PURE__ */ jsx2(
                      Typography2,
                      {
                        variant: "label-M",
                        color: "action",
                        title: pkg.title,
                        style: pkg.color ? { color: pkg.color } : void 0,
                        children: pkg.title
                      }
                    ),
                    /* @__PURE__ */ jsx2(Typography2, { variant: "body-S", color: "text-secondary", children: pkg.subtitle })
                  ]
                },
                pkg.sys.id
              )),
              features.map((feature, idx) => {
                var _a2;
                const isLast = idx === features.length - 1;
                const bgClass = idx % 2 === 0 ? "bg-text-tertiary/20" : "bg-transparent";
                const borderClass = isLast ? "rounded-b-md border" : "border-x";
                return [
                  /* @__PURE__ */ jsxs2(
                    "div",
                    {
                      className: twMerge(
                        "border-text-tertiary/10 flex items-center gap-2 p-2 sm:p-4",
                        bgClass,
                        borderClass
                      ),
                      children: [
                        ((_a2 = feature.icon) == null ? void 0 : _a2.url) && /* @__PURE__ */ jsx2(ContentfulImage_default, { className: "h-fit w-fit shrink-0", src: feature.icon.url }),
                        /* @__PURE__ */ jsx2(Typography2, { variant: "label-S", color: "action", title: feature.title, children: feature.title })
                      ]
                    },
                    `feature-${feature.id || idx}`
                  ),
                  ...packageCards.map((pkg) => {
                    var _a3, _b, _c, _d;
                    const value = (_b = (_a3 = pkg.cmsTagsCollection) == null ? void 0 : _a3.items) == null ? void 0 : _b[idx];
                    return /* @__PURE__ */ jsxs2(
                      "div",
                      {
                        className: twMerge(
                          "border-text-tertiary/10 flex items-center justify-center p-2 sm:p-4",
                          bgClass,
                          borderClass,
                          ((_c = value == null ? void 0 : value.icon) == null ? void 0 : _c.url) && "gap-2"
                        ),
                        style: pkg.color ? __spreadValues({
                          borderLeftColor: pkg.color,
                          borderRightColor: pkg.color,
                          borderLeftWidth: "2px",
                          borderRightWidth: "2px",
                          borderTopColor: "transparent"
                        }, isLast ? { borderBottomColor: pkg.color, borderBottomWidth: "2px" } : {}) : void 0,
                        children: [
                          ((_d = value == null ? void 0 : value.icon) == null ? void 0 : _d.url) ? /* @__PURE__ */ jsx2(ContentfulImage_default, { className: "h-fit w-fit shrink-0", src: value.icon.url }) : null,
                          (value == null ? void 0 : value.title) ? /* @__PURE__ */ jsx2(
                            Typography2,
                            {
                              variant: "label-S",
                              color: "action",
                              className: "text-center",
                              title: value.title,
                              children: value.title
                            }
                          ) : /* @__PURE__ */ jsx2(Typography2, { variant: "label-XS", color: "text-tertiary", children: "\u2014" })
                        ]
                      },
                      `${pkg.sys.id}-${idx}`
                    );
                  })
                ];
              })
            ]
          }
        ) })
      ] })
    }
  );
};
var BenefitsTable_default = BenefitsTable;

// src/components/cards/CardsCarousel.tsx
import { Fragment as Fragment2 } from "react";
import { Button as Button2 } from "@wbk/ui";
import { Link as Link2 } from "@wbk/config";
import { useAnalytics } from "@wbk/analytics";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var CardsCarousel = ({ section }) => {
  var _a, _b;
  const items = section.contentCollection.items;
  const tags = section.tagsCollection.items;
  const { trackEvent } = useAnalytics();
  const { tag, setTag, filteredItems } = useSectionTagFilter({
    items,
    tags
  });
  if (!(items == null ? void 0 : items.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx3(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_cards_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx3(
        CarouselWithLink_default,
        {
          section,
          arrowsClassName: "[&>div:first-child]:min-w-0",
          title: (tags == null ? void 0 : tags.length) ? /* @__PURE__ */ jsxs3("div", { className: "space-y-4", children: [
            /* @__PURE__ */ jsx3(
              CarouselTitle_default,
              {
                section,
                sectionLink: (_b = (_a = section.webLinksCollection) == null ? void 0 : _a.items) == null ? void 0 : _b[0]
              }
            ),
            /* @__PURE__ */ jsx3(SectionTagFilter_default, { tags, activeTag: tag, onSelect: setTag })
          ] }) : void 0,
          children: filteredItems == null ? void 0 : filteredItems.map((parsedItem, index) => {
            var _a2;
            const hasContent = parsedItem.title || (parsedItem == null ? void 0 : parsedItem.subtitle);
            const external = (_a2 = parsedItem.href) == null ? void 0 : _a2.startsWith("http");
            return /* @__PURE__ */ jsx3(Fragment2, { children: /* @__PURE__ */ jsx3(
              Button2,
              {
                as: parsedItem.href ? Link2 : "div",
                theme: "transparent",
                shape: "text",
                "data-testid": `section_cards_carousel_item_${parsedItem.id}`,
                className: "aspect-1 relative mr-4 shrink-0 basis-72 rounded-lg p-0 text-start md:basis-60",
                href: parsedItem.href,
                target: external ? "_blank" : void 0,
                rel: "noreferrer",
                onClick: () => {
                  var _a3;
                  trackEvent({
                    event: "clicked_on_section_item",
                    data: {
                      type: parsedItem.__typename,
                      item_id: (_a3 = parsedItem.sys) == null ? void 0 : _a3.id,
                      slug: parsedItem.href,
                      section: section.id,
                      position: index
                    }
                  });
                },
                children: /* @__PURE__ */ jsxs3("div", { className: "h-full w-full", children: [
                  /* @__PURE__ */ jsx3("div", { className: "from-body/5 via-body/10 to-body/95 absolute inset-0 z-10 bg-gradient-to-b to-90%" }),
                  /* @__PURE__ */ jsxs3("div", { className: "relative h-full overflow-hidden rounded-lg bg-cover transition duration-500", children: [
                    /* @__PURE__ */ jsx3(
                      ContentfulMedia_default,
                      {
                        className: "aspect-1 absolute h-full object-cover",
                        media: parsedItem.image11,
                        width: 800,
                        height: 800,
                        fit: "thumb",
                        ratio: "1x1",
                        placeholder: true,
                        controls: true
                      }
                    ),
                    hasContent && /* @__PURE__ */ jsxs3("div", { className: "flex h-full w-full flex-col justify-between overflow-hidden", children: [
                      /* @__PURE__ */ jsx3("div", {}),
                      /* @__PURE__ */ jsxs3("div", { className: "relative z-50 flex items-end justify-between p-4", children: [
                        /* @__PURE__ */ jsxs3("div", { className: "space-y-2", children: [
                          /* @__PURE__ */ jsx3("p", { className: "text-xl", children: parsedItem == null ? void 0 : parsedItem.title }),
                          (parsedItem == null ? void 0 : parsedItem.subtitle) && /* @__PURE__ */ jsx3("p", { className: "text-sm", children: parsedItem == null ? void 0 : parsedItem.subtitle })
                        ] }),
                        (parsedItem == null ? void 0 : parsedItem.icon) && /* @__PURE__ */ jsx3("div", { className: "shrink-0", children: /* @__PURE__ */ jsx3(
                          ContentfulMedia_default,
                          {
                            media: parsedItem == null ? void 0 : parsedItem.icon,
                            width: 30,
                            height: 31,
                            alt: "",
                            fit: "pad"
                          }
                        ) })
                      ] })
                    ] })
                  ] })
                ] })
              }
            ) }, parsedItem.id);
          })
        }
      )
    }
  );
};
var CardsCarousel_default = CardsCarousel;

// src/components/cards/CardsCarouselMini.tsx
import { Link as Link3 } from "@wbk/config";
import { useAnalytics as useAnalytics2 } from "@wbk/analytics";
import { jsx as jsx4 } from "react/jsx-runtime";
var CardsCarouselMini = ({ section }) => {
  const cards = section.contentCollection.items;
  const { trackEvent } = useAnalytics2();
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsx4(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_cards_carousel_mini_${section.id}`,
      children: /* @__PURE__ */ jsx4(CarouselWithLink_default, { section, linkClassName: "h-40 aspect-1", children: cards.map((card, i) => {
        var _a, _b;
        const isLink = !!card.href && card.href !== "#";
        const isExternal = isLink && ((_a = card.href) == null ? void 0 : _a.startsWith("http"));
        const El = isLink ? Link3 : "div";
        return /* @__PURE__ */ jsx4("div", { className: "flex max-w-xs shrink-0 basis-60 px-2 md:basis-64", children: /* @__PURE__ */ jsx4(
          El,
          {
            to: card.href || "#",
            "data-testid": `section_cards_carousel_mini_item_${card.id}`,
            target: isExternal ? "_blank" : void 0,
            rel: isExternal ? "noreferrer" : "",
            className: "border-body-level-1 relative flex h-40 w-full items-center justify-center overflow-hidden rounded-xl border bg-[linear-gradient(0deg,transparent,var(--color))] p-4 hover:bg-[linear-gradient(0deg,transparent,var(--hover-color))]",
            style: {
              "--color": card.color ? `${card.color}30` : "",
              "--hover-color": card.color ? `${card.color}40` : ""
            },
            "aria-label": card.title,
            onClick: () => {
              var _a2;
              trackEvent({
                event: "clicked_on_section_item",
                data: {
                  type: card.__typename,
                  item_id: (_a2 = card.sys) == null ? void 0 : _a2.id,
                  slug: card.href,
                  section: section.id,
                  position: i
                }
              });
            },
            children: /* @__PURE__ */ jsx4("img", { src: (_b = card.image) == null ? void 0 : _b.url, className: "h-full", alt: "" })
          }
        ) }, card.id + i);
      }) })
    }
  );
};
var CardsCarouselMini_default = CardsCarouselMini;

// src/components/cards/CardsGrid.tsx
import { Link as Link4 } from "@wbk/config";
import { Fragment as Fragment3 } from "react/jsx-runtime";
import { Typography as Typography3 } from "@wbk/ui";
import { useAnalytics as useAnalytics3 } from "@wbk/analytics";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var CardsGrid = ({ section }) => {
  const cards = section.contentCollection.items;
  const { trackEvent } = useAnalytics3();
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsxs4(
    DecoratedSection_default,
    {
      section,
      className: "container overflow-hidden",
      "data-testid": `section_cards_grid_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs4("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx5(Typography3, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx5(Typography3, { color: "text-secondary", className: "mt-1", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx5("div", { className: "flex flex-wrap gap-3 lg:[&>div:nth-child(n+2)]:basis-[calc(33.3%-12px)] lg:[&>div:nth-child(n+4)]:basis-[calc(25%-12px)] [&>div]:basis-full sm:[&>div]:basis-[calc(50%-12px)] md:[&>div]:basis-[calc(50%-12px)] lg:[&>div]:basis-[calc(33.3%-12px)]", children: cards.map((card, i) => {
          var _a;
          const isLink = !!card.href && card.href !== "#";
          const isExternal = isLink && ((_a = card.href) == null ? void 0 : _a.startsWith("http"));
          const El = isLink ? Link4 : "div";
          return /* @__PURE__ */ jsx5(Fragment3, { children: /* @__PURE__ */ jsx5(
            "div",
            {
              className: "[&:nth-child(n+1)]:aspect-1 [&:nth-child(n+3)]:aspect-1 lg:[&:nth-child(n+1)]:aspect-[4/3]",
              children: /* @__PURE__ */ jsxs4(
                El,
                {
                  "data-testid": `section_cards_grid_item_${card.id}`,
                  to: card.href || "#",
                  target: isExternal ? "_blank" : void 0,
                  rel: "noreferrer",
                  className: "group relative flex h-full w-full flex-col justify-between focus:z-10",
                  onClick: () => {
                    var _a2;
                    trackEvent({
                      event: "clicked_on_section_item",
                      data: {
                        type: card.__typename,
                        item_id: (_a2 = card.sys) == null ? void 0 : _a2.id,
                        slug: card.href,
                        section: section.id,
                        position: i
                      }
                    });
                  },
                  children: [
                    /* @__PURE__ */ jsx5("div", { className: "from-body/5 via-body/10 to-body/95 absolute inset-0 z-10 scale-105 bg-gradient-to-b to-90%" }),
                    /* @__PURE__ */ jsxs4("div", { className: "flex-co justify-betweenl relative flex h-full overflow-hidden rounded-lg transition duration-500", children: [
                      /* @__PURE__ */ jsx5(
                        ContentfulMedia_default,
                        {
                          media: card.image,
                          className: "absolute -z-10 h-full w-full object-cover",
                          placeholder: true
                        }
                      ),
                      /* @__PURE__ */ jsx5("div", {}),
                      /* @__PURE__ */ jsxs4("div", { className: "relative z-10 flex items-end justify-between p-4", children: [
                        /* @__PURE__ */ jsxs4("div", { className: "space-y-2", children: [
                          /* @__PURE__ */ jsx5("p", { className: "text-xl", children: card.title }),
                          card.subtitle && /* @__PURE__ */ jsx5("p", { className: "text-sm", children: card.subtitle })
                        ] }),
                        card.icon && /* @__PURE__ */ jsx5("div", { className: "shrink-0", children: /* @__PURE__ */ jsx5(
                          ContentfulMedia_default,
                          {
                            media: card.icon,
                            width: 30,
                            height: 31,
                            alt: "",
                            fit: "pad"
                          }
                        ) })
                      ] })
                    ] })
                  ]
                }
              )
            },
            card.id
          ) }, i);
        }) })
      ]
    }
  );
};
var CardsGrid_default = CardsGrid;

// src/components/cards/CardsInfoCarousel.tsx
import { Fragment as Fragment4 } from "react";
import { Button as Button3, Typography as Typography4 } from "@wbk/ui";
import { Link as Link5, useRouter } from "@wbk/config";
import { useAnalytics as useAnalytics4 } from "@wbk/analytics";
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var CardsInfoCarousel = ({ section }) => {
  const items = section.contentCollection.items;
  const { locale } = useRouter();
  const { trackEvent } = useAnalytics4();
  if (!(items == null ? void 0 : items.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx6(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_cards_info_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx6(CarouselWithLink_default, { section, children: items.map((item, index) => {
        var _a;
        const parsedItem = parseSectionItem({ item, locale });
        if (!parsedItem) return null;
        const external = (_a = parsedItem.href) == null ? void 0 : _a.startsWith("http");
        return /* @__PURE__ */ jsx6(Fragment4, { children: /* @__PURE__ */ jsx6(
          Button3,
          {
            as: parsedItem.href ? Link5 : "div",
            theme: "transparent",
            shape: "text",
            "data-testid": `section_cards_info_carousel_item_${parsedItem.id}`,
            className: "relative mr-4 shrink-0 basis-72 rounded-lg p-0 text-start md:basis-80",
            href: parsedItem.href ? parsedItem.href : void 0,
            target: external ? "_blank" : void 0,
            rel: "noreferrer",
            onClick: () => {
              var _a2;
              trackEvent({
                event: "clicked_on_section_item",
                data: {
                  type: parsedItem.__typename,
                  item_id: (_a2 = parsedItem.sys) == null ? void 0 : _a2.id,
                  slug: parsedItem.href,
                  section: section.id,
                  position: index
                }
              });
            },
            children: /* @__PURE__ */ jsxs5("div", { className: "rounded-S bg-body flex h-full w-full flex-col items-start overflow-hidden", children: [
              /* @__PURE__ */ jsx6("div", { className: "h-full w-full", children: (parsedItem == null ? void 0 : parsedItem.image11) && /* @__PURE__ */ jsx6(
                ContentfulMedia_default,
                {
                  className: "aspect-1 h-full rounded-md object-cover",
                  media: parsedItem == null ? void 0 : parsedItem.image11,
                  width: 600,
                  height: 600,
                  ratio: "1x1",
                  fit: "thumb",
                  placeholder: true,
                  controls: true
                }
              ) }),
              /* @__PURE__ */ jsxs5("div", { className: "space-y-0.5 pt-2", children: [
                /* @__PURE__ */ jsx6(Typography4, { variant: "body-S", color: "text-secondary", children: parsedItem.subtitle }),
                /* @__PURE__ */ jsx6(Typography4, { strong: true, children: parsedItem.title }),
                parsedItem.description && /* @__PURE__ */ jsx6(Typography4, { variant: "body-S", color: "text-secondary", children: parsedItem.description })
              ] })
            ] })
          }
        ) }, parsedItem.id);
      }) })
    }
  );
};
var CardsInfoCarousel_default = CardsInfoCarousel;

// src/components/cards/SquareGrid.tsx
import { Link as Link6 } from "@wbk/config";
import { Typography as Typography5 } from "@wbk/ui";
import { useAnalytics as useAnalytics5 } from "@wbk/analytics";
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var CardsSquareGrid = ({ section }) => {
  const cards = section.contentCollection.items;
  const { trackEvent } = useAnalytics5();
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsxs6(
    DecoratedSection_default,
    {
      section,
      className: "container overflow-hidden",
      "data-testid": `section_cards_square_grid_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs6("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx7(Typography5, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx7(Typography5, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx7("div", { className: "grid grid-cols-2 gap-4 sm:grid-cols-[repeat(auto-fill,minmax(240px,1fr))]", children: cards.map((card, i) => {
          var _a;
          const isLink = !!card.href && card.href !== "#";
          const isExternal = isLink && ((_a = card.href) == null ? void 0 : _a.startsWith("http"));
          const El = isLink ? Link6 : "div";
          return /* @__PURE__ */ jsxs6(
            El,
            {
              to: card.href || "#",
              target: isExternal ? "_blank" : void 0,
              rel: "noreferrer",
              className: "border-paper flex flex-col items-center justify-center rounded-xl border bg-[linear-gradient(0deg,transparent,var(--color))] p-4 hover:bg-[linear-gradient(0deg,transparent,var(--hover-color))]",
              style: {
                "--color": card.color ? `${card.color}30` : "",
                "--hover-color": card.color ? `${card.color}40` : ""
              },
              onClick: () => {
                var _a2;
                trackEvent({
                  event: "clicked_on_section_item",
                  data: {
                    type: card.__typename,
                    item_id: (_a2 = card.sys) == null ? void 0 : _a2.id,
                    slug: card.href,
                    section: section.id,
                    position: i
                  }
                });
              },
              children: [
                /* @__PURE__ */ jsx7(
                  ContentfulMedia_default,
                  {
                    className: "aspect-1 h-40 object-contain md:h-60",
                    media: card.image
                  }
                ),
                /* @__PURE__ */ jsx7("p", { className: "mt-4", children: card.title })
              ]
            },
            i
          );
        }) })
      ]
    }
  );
};
var SquareGrid_default = CardsSquareGrid;

// src/components/cards/FAQsCards.tsx
import { useState } from "react";
import { motion } from "motion/react";
import { Button as Button4, Collapsible, Reveal, Typography as Typography6 } from "@wbk/ui";
import { useAnalytics as useAnalytics6 } from "@wbk/analytics";
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var PlusMinusIcon = ({ open }) => /* @__PURE__ */ jsxs7("span", { className: "relative block h-4 w-4 shrink-0", children: [
  /* @__PURE__ */ jsx8("span", { className: "bg-text absolute left-0 top-1/2 h-0.5 w-full -translate-y-1/2" }),
  /* @__PURE__ */ jsx8(
    motion.span,
    {
      className: "bg-text absolute left-1/2 top-0 h-full w-0.5",
      style: { x: "-50%" },
      animate: { scaleY: open ? 0 : 1 },
      transition: { duration: 0.3 }
    }
  )
] });
var FAQItem = ({ card, open, onOpenChange }) => {
  const { trackEvent } = useAnalytics6();
  return /* @__PURE__ */ jsx8("div", { className: "bg-action/10 hover:border-action/20 w-full overflow-hidden rounded-xl border border-transparent transition-all", children: /* @__PURE__ */ jsx8(
    Collapsible,
    {
      open,
      onOpenChange: (next) => {
        onOpenChange(next);
        if (next) {
          trackEvent({
            event: "plus_faq_expanded",
            data: {
              id: card.id,
              text: card.title
            }
          });
        }
      },
      trigger: /* @__PURE__ */ jsxs7(
        Button4,
        {
          className: "flex w-full items-center justify-between gap-0 p-4",
          theme: "transparent",
          children: [
            /* @__PURE__ */ jsx8(Typography6, { variant: "heading-XS", className: "w-full text-start", children: card.title }),
            /* @__PURE__ */ jsx8("span", { className: "flex w-10 shrink-0 items-center justify-center lg:w-12", children: /* @__PURE__ */ jsx8(PlusMinusIcon, { open }) })
          ]
        }
      ),
      children: card.description && /* @__PURE__ */ jsx8(
        Typography6,
        {
          variant: "body-S",
          className: "px-2 pb-4 pt-0 lg:px-4",
          dangerouslySetInnerHTML: { __html: card.description },
          color: "text-secondary"
        }
      )
    }
  ) });
};
var FAQsCards = ({ section }) => {
  const cards = section.contentCollection.items;
  const [openId, setOpenId] = useState(null);
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsx8(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_faqs_cards_${section.id}`,
      children: /* @__PURE__ */ jsxs7("div", { className: "flex flex-col items-center gap-6 lg:flex-row lg:gap-10", children: [
        section.title && /* @__PURE__ */ jsx8(Reveal, { threshold: 0.2, distance: 26, duration: 0.7, className: "w-full lg:w-1/2", children: /* @__PURE__ */ jsx8(Typography6, { as: "h2", variant: "heading-L", strong: true, children: section.title }) }),
        /* @__PURE__ */ jsx8("div", { className: "w-full space-y-3 lg:w-1/2", children: cards.map((card, index) => {
          const itemId = card.id || index;
          return /* @__PURE__ */ jsx8(
            Reveal,
            {
              threshold: 0.2,
              distance: 26,
              duration: 0.7,
              delay: index * 0.06,
              children: /* @__PURE__ */ jsx8(
                FAQItem,
                {
                  card,
                  open: openId === itemId,
                  onOpenChange: (next) => setOpenId(next ? itemId : null)
                }
              )
            },
            itemId
          );
        }) })
      ] })
    }
  );
};
var FAQsCards_default = FAQsCards;

// src/components/cards/ImageInfoCarousel.tsx
import { Carousel, CollapsibleText, Typography as Typography7 } from "@wbk/ui";
import { Link as Link7 } from "@wbk/config";
import { useAnalytics as useAnalytics7 } from "@wbk/analytics";
import { Fragment as Fragment5, jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var ImageInfoCarousel = ({ section }) => {
  var _a;
  const cards = section.contentCollection.items;
  const { trackEvent } = useAnalytics7();
  const actionBg = (_a = section == null ? void 0 : section.theme) == null ? void 0 : _a.action;
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsx9(
    DecoratedSection_default,
    {
      section,
      "data-testid": `section_image_info_carousel_${section.id}`,
      className: "container",
      id: section.id,
      children: /* @__PURE__ */ jsx9(
        Carousel,
        {
          className: "p-1",
          title: /* @__PURE__ */ jsxs8(Fragment5, { children: [
            section.title && /* @__PURE__ */ jsx9(Typography7, { as: "h2", variant: "heading-L", children: section.title }),
            section.subtitle && /* @__PURE__ */ jsx9(Typography7, { color: "text-secondary", className: "mt-1", children: section.subtitle })
          ] }),
          arrows: "top",
          children: cards.map((card, i) => {
            var _a2, _b, _c;
            const isLink = !!card.href && card.href !== "#";
            const isExternal = isLink && ((_a2 = card.href) == null ? void 0 : _a2.startsWith("http"));
            const El = isLink ? Link7 : "div";
            return /* @__PURE__ */ jsxs8(
              El,
              {
                "data-testid": `section_cards_carousel_item_${card.id}`,
                className: "data-[action=false]:gap-L relative flex shrink-0 basis-full flex-col overflow-hidden rounded-xl md:flex-row ltr:mr-4 ltr:last:mr-0 rtl:ml-4 rtl:last:ml-0",
                to: card.href || "#",
                target: isExternal ? "_blank" : void 0,
                rel: "noreferrer",
                "data-action": !!actionBg,
                onClick: () => {
                  var _a3;
                  trackEvent({
                    event: "clicked_on_section_item",
                    data: {
                      type: card.__typename,
                      item_id: (_a3 = card.sys) == null ? void 0 : _a3.id,
                      slug: card.href,
                      section: section.id,
                      position: i
                    }
                  });
                },
                children: [
                  /* @__PURE__ */ jsxs8(
                    "div",
                    {
                      className: "data-[action=true]:bg-action/10 shrink-0 space-y-5 data-[action=true]:p-6 md:max-w-sm data-[action=true]:md:p-8",
                      "data-action": !!actionBg,
                      children: [
                        card.image11 && /* @__PURE__ */ jsx9(
                          ContentfulMedia_default,
                          {
                            media: card.image11,
                            className: "aspect-[3/2] w-full rounded-[4px]"
                          }
                        ),
                        !!section.logo && /* @__PURE__ */ jsx9(ContentfulMedia_default, { media: section.logo }),
                        card.title && /* @__PURE__ */ jsx9("h3", { className: "text-3xl font-normal", children: card.title }),
                        card.description && /* @__PURE__ */ jsx9(CollapsibleText, { text: card.description, className: "text-text-secondary" }),
                        !!((_c = (_b = section.webLinksCollection) == null ? void 0 : _b.items) == null ? void 0 : _c.length) && /* @__PURE__ */ jsx9("div", { className: "mt-6 flex flex-wrap gap-px", children: section.webLinksCollection.items.map((link) => /* @__PURE__ */ jsx9(ContentfulButton_default, { link }, link.id)) })
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx9("div", { className: "grow", children: /* @__PURE__ */ jsx9(
                    ContentfulMedia_default,
                    {
                      media: card.image,
                      alt: card.title,
                      className: "aspect-[3/2] w-full object-contain"
                    }
                  ) })
                ]
              },
              i
            );
          })
        }
      )
    }
  );
};
var ImageInfoCarousel_default = ImageInfoCarousel;

// src/components/cards/InstagramCardsCarousel.tsx
import { Carousel as Carousel2, Typography as Typography8 } from "@wbk/ui";
import { Link as Link8, useTranslation as useTranslation2 } from "@wbk/config";
import { useAnalytics as useAnalytics8 } from "@wbk/analytics";
import { Fragment as Fragment6, jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var InstagramCardsCarousel = ({ section }) => {
  const cards = section.contentCollection.items;
  const { t } = useTranslation2(["contentful_zone"]);
  const { trackEvent } = useAnalytics8();
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsx10(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_cards_carousel_${section.id}`,
      children: /* @__PURE__ */ jsx10(
        Carousel2,
        {
          options: { dragFree: true },
          className: "p-1",
          title: /* @__PURE__ */ jsxs9(Fragment6, { children: [
            section.title && /* @__PURE__ */ jsx10(Typography8, { as: "h2", variant: "heading-L", children: section.title }),
            section.subtitle && /* @__PURE__ */ jsx10(Typography8, { color: "text-secondary", className: "mt-1", children: section.subtitle })
          ] }),
          arrows: "top",
          children: cards.map((card, i) => {
            var _a;
            const isLink = !!card.href && card.href !== "#";
            const isExternal = isLink && ((_a = card.href) == null ? void 0 : _a.startsWith("http"));
            const El = isLink ? Link8 : "div";
            return /* @__PURE__ */ jsxs9(
              El,
              {
                "data-testid": `section_cards_carousel_item_${card.id}`,
                to: card.href || "#",
                target: isExternal ? "_blank" : void 0,
                rel: "noreferrer",
                className: "border-paper relative mr-4 shrink-0 basis-[80%] overflow-hidden rounded-lg border sm:basis-1/2 md:basis-[calc(40%-16px)] lg:basis-[calc(33.33%-16px)]",
                onClick: () => {
                  var _a2;
                  trackEvent({
                    event: "clicked_on_section_item",
                    data: {
                      type: card.__typename,
                      item_id: (_a2 = card.sys) == null ? void 0 : _a2.id,
                      slug: card.href,
                      section: section.id,
                      position: i
                    }
                  });
                },
                children: [
                  /* @__PURE__ */ jsxs9("div", { className: "space-y-4 p-4 lg:p-6", children: [
                    /* @__PURE__ */ jsxs9("div", { className: "flex items-center gap-4", children: [
                      /* @__PURE__ */ jsx10(
                        ContentfulMedia_default,
                        {
                          className: "aspect-1 h-16 w-16 shrink-0 rounded-full",
                          media: card.image,
                          width: 64,
                          height: 64,
                          fit: "thumb",
                          ratio: "1x1",
                          placeholder: true
                        }
                      ),
                      /* @__PURE__ */ jsxs9("div", { className: "space-y-1", children: [
                        /* @__PURE__ */ jsx10("h3", { className: "text-xl font-semibold", children: card.title }),
                        card.subtitle && /* @__PURE__ */ jsx10("p", { className: "text-text-secondary", children: card.subtitle })
                      ] }),
                      card.icon && /* @__PURE__ */ jsx10(
                        ContentfulMedia_default,
                        {
                          className: "xs:block hidden max-w-9 shrink-0 ltr:ml-auto rtl:mr-auto",
                          media: card.icon,
                          width: 36,
                          height: 36
                        }
                      )
                    ] }),
                    /* @__PURE__ */ jsxs9("div", { className: "space-y-2", children: [
                      card.description && /* @__PURE__ */ jsx10("p", { className: "text-text-secondary", children: card.description }),
                      card.href && /* @__PURE__ */ jsx10("p", { className: "font-semibold underline", children: card.buttonLabel || t("contentful_zone:see_more") })
                    ] })
                  ] }),
                  card.image11 && /* @__PURE__ */ jsx10(
                    ContentfulMedia_default,
                    {
                      className: "aspect-1 rounded-t-lg",
                      media: card.image11,
                      width: 500,
                      height: 500,
                      fit: "thumb",
                      ratio: "1x1",
                      placeholder: true,
                      controls: true
                    }
                  )
                ]
              },
              i
            );
          })
        }
      )
    }
  );
};
var InstagramCardsCarousel_default = InstagramCardsCarousel;

// src/components/cards/LinkCards.tsx
import { twMerge as twMerge2 } from "tailwind-merge";
import { Link as Link9 } from "@wbk/config";
import { Button as Button5, Typography as Typography9 } from "@wbk/ui";
import { useAnalytics as useAnalytics9 } from "@wbk/analytics";
import { ChevronIcon } from "@wbk/svg";
import { jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
var LinkCards = ({ section }) => {
  const cards = section.contentCollection.items;
  const { trackEvent } = useAnalytics9();
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsxs10(
    DecoratedSection_default,
    {
      section,
      className: "container overflow-hidden",
      "data-testid": `section_link_cards_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs10("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx11(Typography9, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx11(Typography9, { color: "text-secondary", className: "mt-1", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx11("div", { className: "gap-S flex w-full flex-wrap", children: cards.map((card, index) => {
          var _a;
          const isLink = !!card.href && card.href !== "#";
          const isExternal = isLink && ((_a = card.href) == null ? void 0 : _a.startsWith("http"));
          return /* @__PURE__ */ jsx11(
            Button5,
            {
              "data-testid": `section_link_cards_grid_item_${card.id}`,
              theme: "action",
              shape: "outlined",
              as: isLink ? Link9 : "div",
              href: card.href ? card.href : "#",
              target: isExternal ? "_blank" : void 0,
              rel: "noreferrer",
              className: twMerge2(
                "py-M px-M border-paper/10 group relative flex flex-1 flex-col justify-between focus:z-10",
                (card == null ? void 0 : card.description) ? "basis-full sm:basis-[calc(33%-16px)]" : "basis-[calc(50%-8px)] sm:basis-auto"
              ),
              onClick: () => {
                var _a2;
                trackEvent({
                  event: "clicked_on_section_item",
                  data: {
                    type: card.__typename,
                    item_id: (_a2 = card.sys) == null ? void 0 : _a2.id,
                    slug: card.href,
                    section: section.id,
                    position: index
                  }
                });
              },
              children: /* @__PURE__ */ jsxs10("div", { className: "gap-L flex h-full w-full flex-col justify-between", children: [
                card.icon && /* @__PURE__ */ jsx11("div", { className: "shrink-0", children: /* @__PURE__ */ jsx11(ContentfulMedia_default, { media: card.icon, className: "h-6 w-6" }) }),
                /* @__PURE__ */ jsxs10("div", { className: "space-y-S pe-M text-start", children: [
                  /* @__PURE__ */ jsx11(Typography9, { variant: "label-L", children: card.title }),
                  (card == null ? void 0 : card.description) && /* @__PURE__ */ jsx11(CollapsableText_default, { text: card.description })
                ] }),
                (card == null ? void 0 : card.href) && /* @__PURE__ */ jsx11(ChevronIcon, { className: "absolute bottom-6 h-4 w-4 shrink-0 justify-self-end ltr:right-4 ltr:rotate-0 rtl:left-4 rtl:rotate-180" })
              ] })
            },
            card.id
          );
        }) })
      ]
    }
  );
};
var LinkCards_default = LinkCards;

// src/components/cards/PerksGrid.tsx
import { useEffect as useEffect2, useRef as useRef2, useState as useState2 } from "react";
import { motion as motion2, useMotionValue, useSpring } from "motion/react";
import { Paper, Typography as Typography10 } from "@wbk/ui";
import { jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var FINE_POINTER = "(hover: hover) and (pointer: fine)";
var PerkCard = ({
  card,
  delay,
  spotlightEnabled
}) => {
  const ref = useRef2(null);
  const rotateX = useSpring(0, { stiffness: 300, damping: 25 });
  const rotateY = useSpring(0, { stiffness: 300, damping: 25 });
  const tiltY = useSpring(0, { stiffness: 300, damping: 25 });
  const isFinePointer = useMotionValue(false);
  return /* @__PURE__ */ jsx12(
    motion2.div,
    {
      className: "h-full",
      initial: { opacity: 0, y: 26 },
      whileInView: { opacity: 1, y: 0 },
      viewport: { once: true, amount: 0.2 },
      transition: { duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] },
      children: /* @__PURE__ */ jsx12(
        motion2.div,
        {
          ref,
          className: "h-full",
          style: { rotateX, rotateY, y: tiltY, perspective: 700, transformStyle: "preserve-3d" },
          onPointerEnter: () => {
            isFinePointer.set(window.matchMedia(FINE_POINTER).matches);
          },
          onPointerMove: (e) => {
            if (!isFinePointer.get() || !ref.current) return;
            const rect = ref.current.getBoundingClientRect();
            const px = (e.clientX - rect.left) / rect.width - 0.5;
            const py = (e.clientY - rect.top) / rect.height - 0.5;
            rotateX.set(py * -6);
            rotateY.set(px * 8);
            tiltY.set(-2);
          },
          onPointerLeave: () => {
            rotateX.set(0);
            rotateY.set(0);
            tiltY.set(0);
          },
          children: /* @__PURE__ */ jsxs11(
            Paper,
            {
              size: "L",
              className: "rounded-XL group relative isolate flex h-full flex-col justify-start overflow-hidden shadow-lg backdrop-blur-xl",
              onPointerMove: (e) => {
                if (!spotlightEnabled || !card.color) return;
                const rect = e.currentTarget.getBoundingClientRect();
                e.currentTarget.style.setProperty("--mx", `${e.clientX - rect.left}px`);
                e.currentTarget.style.setProperty("--my", `${e.clientY - rect.top}px`);
              },
              children: [
                spotlightEnabled && card.color && /* @__PURE__ */ jsx12(
                  "div",
                  {
                    "aria-hidden": true,
                    className: "rounded-XL pointer-events-none absolute inset-0 -z-10 opacity-0 transition-opacity duration-300 group-hover:opacity-100",
                    style: {
                      background: `radial-gradient(340px circle at var(--mx, 50%) var(--my, 40%), ${card.color}b3 0%, ${card.color}40 25%, transparent 70%)`
                    }
                  }
                ),
                card.image && /* @__PURE__ */ jsx12(ContentfulMedia_default, { media: card.image, className: "mb-5" }),
                /* @__PURE__ */ jsxs11("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ jsx12(Typography10, { variant: "body-L", strong: true, children: card.title }),
                  card.subtitle && /* @__PURE__ */ jsx12(Typography10, { variant: "body-M", color: "text-secondary", children: card.subtitle })
                ] })
              ]
            }
          )
        }
      )
    }
  );
};
var PerksGrid = ({ section }) => {
  const cards = section.contentCollection.items;
  const [spotlightEnabled, setSpotlightEnabled] = useState2(false);
  useEffect2(() => {
    setSpotlightEnabled(window.matchMedia("(hover: hover) and (pointer: fine)").matches);
  }, []);
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsxs11(
    DecoratedSection_default,
    {
      section,
      className: "container overflow-hidden",
      "data-testid": `section_perks_grid_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs11(
          motion2.div,
          {
            initial: { opacity: 0, y: 26 },
            whileInView: { opacity: 1, y: 0 },
            viewport: { once: true, amount: 0.2 },
            transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
            className: "space-y-1",
            children: [
              /* @__PURE__ */ jsx12(Typography10, { as: "h2", variant: "heading-L", children: section.title }),
              section.subtitle && /* @__PURE__ */ jsx12(Typography10, { color: "text-secondary", className: "mt-1", children: section.subtitle })
            ]
          }
        ),
        /* @__PURE__ */ jsx12("div", { className: "grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4", children: cards.map((card, index) => /* @__PURE__ */ jsx12(
          PerkCard,
          {
            card,
            delay: index * 0.06,
            spotlightEnabled
          },
          card.id || index
        )) })
      ]
    }
  );
};
var PerksGrid_default = PerksGrid;

// src/components/cards/SocialCardsAsync.tsx
import { useRouter as useRouter2 } from "@wbk/config";

// src/components/cards/SocialCardsSection.tsx
import { Paper as Paper2, Typography as Typography12 } from "@wbk/ui";
import { twMerge as twMerge4 } from "tailwind-merge";

// src/components/cards/SocialCardItem.tsx
import { twMerge as twMerge3 } from "tailwind-merge";
import { Button as Button6, Typography as Typography11 } from "@wbk/ui";
import { useAnalytics as useAnalytics10 } from "@wbk/analytics";
import { jsx as jsx13, jsxs as jsxs12 } from "react/jsx-runtime";
var SocialCardItem = ({ card, layout = "vertical", sectionId, index }) => {
  const { trackEvent } = useAnalytics10();
  const handleClick = () => {
    trackEvent({
      event: "clicked_on_section_item",
      data: {
        platform: card.title,
        section: sectionId,
        card_id: card.id,
        slug: card.href,
        label: card.title,
        type: "social",
        position: index
      }
    });
  };
  return /* @__PURE__ */ jsxs12(
    "div",
    {
      className: twMerge3(
        "gap-S flex flex-col items-center justify-center",
        layout === "horizontal" && "xl:flex-row"
      ),
      children: [
        /* @__PURE__ */ jsx13(
          ContentfulMedia_default,
          {
            media: card.image,
            className: "h-6 w-6 shrink-0 object-contain md:h-9 md:w-9"
          }
        ),
        /* @__PURE__ */ jsxs12("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsxs12("div", { className: "flex items-center justify-center gap-1 xl:justify-start", children: [
            /* @__PURE__ */ jsx13(Typography11, { variant: "label-XS", children: card.title }),
            card.icon && /* @__PURE__ */ jsx13(
              ContentfulMedia_default,
              {
                media: card.icon,
                width: 9,
                height: 9,
                className: "h-2.5 w-2.5 shrink-0 object-contain"
              }
            )
          ] }),
          card.subtitle && /* @__PURE__ */ jsx13(Typography11, { variant: "body-XXS", color: "text-secondary", children: card.subtitle })
        ] }),
        card.href ? /* @__PURE__ */ jsx13(
          Button6,
          {
            as: "a",
            href: card.href,
            target: "_blank",
            rel: "noreferrer noopener",
            theme: "action",
            shape: "outlined",
            onClick: handleClick,
            className: twMerge3(
              "border-paper-level-1 py-XXS px-XS",
              layout === "horizontal" && "xl:ms-XS"
            ),
            children: /* @__PURE__ */ jsx13(Typography11, { variant: "body-XS", strong: true, children: card.buttonLabel })
          }
        ) : null
      ]
    }
  );
};
var SocialCardItem_default = SocialCardItem;

// src/components/cards/SocialCardsSection.tsx
import { jsx as jsx14, jsxs as jsxs13 } from "react/jsx-runtime";
var SocialCardsSection = ({ section, layout, className }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsx14(DecoratedSection_default, { className, section, children: /* @__PURE__ */ jsxs13(
    Paper2,
    {
      className: twMerge4(
        "flex flex-col items-center gap-4",
        layout === "by-aside" && "2xl:flex-row",
        !layout && "lg:flex-row"
      ),
      children: [
        section.logo && /* @__PURE__ */ jsx14(
          ContentfulMedia_default,
          {
            media: section.logo,
            className: twMerge4(
              "h-auto w-auto max-w-40 shrink-0 object-contain",
              !layout && "lg:max-w-36 2xl:max-w-24"
            ),
            alt: section.title || "Social media image"
          }
        ),
        /* @__PURE__ */ jsxs13(
          "div",
          {
            className: twMerge4(
              "flex grow flex-col flex-wrap items-center justify-center gap-4 2xl:flex-nowrap",
              layout === "by-aside" && "2xl:flex-row 2xl:justify-between",
              !layout && "lg:flex-row lg:justify-between"
            ),
            children: [
              /* @__PURE__ */ jsxs13(
                "div",
                {
                  className: twMerge4(
                    "flex shrink flex-col justify-center gap-2 text-center",
                    layout === "by-aside" && "2xl:text-start",
                    !layout && "lg:text-start"
                  ),
                  children: [
                    section.title && /* @__PURE__ */ jsx14(Typography12, { variant: "heading-M", className: "shrink", children: section.title }),
                    section.subtitle && /* @__PURE__ */ jsx14(Typography12, { color: "text-secondary", variant: "body-S", children: section.subtitle })
                  ]
                }
              ),
              /* @__PURE__ */ jsx14(
                "div",
                {
                  className: twMerge4(
                    "flex items-center justify-center gap-8 2xl:justify-between",
                    !layout && "xl:divide-paper-level-1 xl:gap-4 xl:divide-x rtl:divide-x-reverse xl:[&>:not(:first-child)]:ps-4"
                  ),
                  children: cards.map((card, idx) => /* @__PURE__ */ jsx14(
                    SocialCardItem_default,
                    {
                      card,
                      layout: !layout ? "horizontal" : "vertical",
                      sectionId: section.id
                    },
                    card.id || idx
                  ))
                }
              )
            ]
          }
        )
      ]
    }
  ) });
};
var SocialCardsSection_default = SocialCardsSection;

// src/components/cards/SocialCardsAsync.tsx
import { jsx as jsx15 } from "react/jsx-runtime";
var SocialCardsAsync = ({ id, className, countryCode, layout }) => {
  var _a;
  const { locale } = useRouter2();
  const sectionId = countryCode ? `webook_social_${countryCode}` : id || "webook_social_SA";
  const { data } = useSections({
    limit: 1,
    lang: locale,
    where: { id: sectionId }
  });
  const displaySection = (_a = data == null ? void 0 : data.items) == null ? void 0 : _a[0];
  if (!displaySection) return null;
  return /* @__PURE__ */ jsx15(SocialCardsSection_default, { section: displaySection, layout, className });
};
var SocialCardsAsync_default = SocialCardsAsync;

// src/components/cards/StandingsTable.tsx
import { useMemo } from "react";
import { twMerge as twMerge5 } from "tailwind-merge";
import { ImageWithPlaceholder, Paper as Paper3, Typography as Typography13 } from "@wbk/ui";
import { useRouter as useRouter3, useTranslation as useTranslation3 } from "@wbk/config";
import { useGetEventsGroupDetails, useGetOrganizationBySlug } from "@wbk/api/hooks";
import { jsx as jsx16, jsxs as jsxs14 } from "react/jsx-runtime";
var StandingsTable = ({ section }) => {
  var _a, _b;
  const organizationSlug = section.organizationSlug;
  const cards = section.contentCollection.items;
  const { locale } = useRouter3();
  const { t } = useTranslation3("contentful_common");
  const {
    data: orgData,
    isLoading: orgLoading,
    error: orgError
  } = useGetOrganizationBySlug(
    { lang: locale, slug: organizationSlug },
    { enabled: !!organizationSlug }
  );
  const { data, isLoading, error } = useGetEventsGroupDetails(
    { lang: locale, organizationsSlug: organizationSlug },
    { enabled: !!organizationSlug }
  );
  const firstGroupWithTable = data == null ? void 0 : data.find((g) => g.points_table);
  const teamsMap = useMemo(() => {
    var _a2;
    const map = {};
    (_a2 = orgData == null ? void 0 : orgData.teams) == null ? void 0 : _a2.forEach((team) => {
      map[team._id] = team;
    });
    return map;
  }, [orgData == null ? void 0 : orgData.teams]);
  if (error || orgError || !firstGroupWithTable || !data || !orgData) return null;
  return /* @__PURE__ */ jsx16(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_table_${section.id}`,
      children: /* @__PURE__ */ jsxs14("div", { className: "space-y-L", children: [
        section.title && /* @__PURE__ */ jsxs14("div", { className: "space-y-XXS text-center", children: [
          /* @__PURE__ */ jsx16(Typography13, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx16(Typography13, { color: "text-secondary", children: section.subtitle })
        ] }),
        orgLoading || isLoading ? /* @__PURE__ */ jsx16("div", { className: "bg-paper-level-2 rounded-S h-96 w-full animate-pulse" }) : /* @__PURE__ */ jsxs14(Paper3, { surface: "level-1", className: "space-y-XS overflow-hidden px-0 py-0", children: [
          /* @__PURE__ */ jsxs14("div", { className: "pt-M px-L font-uppercase grid grid-cols-[25%_50%_25%] sm:grid-cols-[20%_30%_30%_20%]", children: [
            /* @__PURE__ */ jsx16(Typography13, { variant: "body-S", className: "shrink-0", children: "#" }),
            /* @__PURE__ */ jsx16(Typography13, { variant: "body-S", className: "shrink-0", children: t("contentful_common:driver") }),
            /* @__PURE__ */ jsx16(Typography13, { variant: "body-S", className: "hidden shrink-0 sm:block", children: t("contentful_common:team") }),
            /* @__PURE__ */ jsx16(Typography13, { variant: "body-S", className: "shrink-0 text-end", children: t("contentful_common:points_short") })
          ] }),
          (_b = (_a = firstGroupWithTable == null ? void 0 : firstGroupWithTable.points_table) == null ? void 0 : _a.table) == null ? void 0 : _b.map((row, index) => {
            var _a2;
            const team = teamsMap[row.team_id];
            const card = cards == null ? void 0 : cards[index];
            const bgImage = (_a2 = card == null ? void 0 : card.image) == null ? void 0 : _a2.url;
            return /* @__PURE__ */ jsxs14(
              "div",
              {
                className: twMerge5(
                  "py-S px-L mt-10 grid grid-cols-[25%_50%_25%] items-center overflow-hidden sm:grid-cols-[20%_30%_30%_20%]",
                  bgImage ? "bg-cover bg-center" : "bg-body/60"
                ),
                style: bgImage ? { backgroundImage: `url(${bgImage})` } : void 0,
                children: [
                  /* @__PURE__ */ jsx16(Typography13, { variant: "label-L", as: "h4", children: index + 1 }),
                  /* @__PURE__ */ jsxs14("div", { className: "relative flex items-center gap-3", children: [
                    /* @__PURE__ */ jsx16(
                      ImageWithPlaceholder,
                      {
                        src: team == null ? void 0 : team.logo,
                        alt: (team == null ? void 0 : team.name) || "",
                        className: "absolute -start-11 top-1/2 h-12 w-8 shrink-0 -translate-y-1/2 object-cover"
                      }
                    ),
                    /* @__PURE__ */ jsx16(Typography13, { variant: "label-L", as: "h4", children: team == null ? void 0 : team.name })
                  ] }),
                  /* @__PURE__ */ jsx16(Typography13, { variant: "label-L", className: "hidden sm:block", children: (team == null ? void 0 : team.description) || "\u2014" }),
                  /* @__PURE__ */ jsx16(Typography13, { variant: "label-L", className: "text-end", as: "h4", children: row.points })
                ]
              },
              row.team_id
            );
          })
        ] })
      ] })
    }
  );
};
var StandingsTable_default = StandingsTable;

// src/components/cards/StatsGrid.tsx
import { Typography as Typography14 } from "@wbk/ui";
import { jsx as jsx17, jsxs as jsxs15 } from "react/jsx-runtime";
var StatsGrid = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsxs15(
    DecoratedSection_default,
    {
      section,
      className: "container overflow-hidden",
      "data-testid": `section_stats_grid_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs15("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx17(Typography14, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx17(Typography14, { color: "text-secondary", className: "mt-1", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx17("div", { className: "grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4", children: cards.map((card, index) => /* @__PURE__ */ jsxs15("div", { className: "flex flex-col gap-2 text-center", children: [
          /* @__PURE__ */ jsx17(Typography14, { variant: "heading-XXL", children: card.title }),
          card.subtitle && /* @__PURE__ */ jsx17(Typography14, { variant: "body-L", color: "text-secondary", children: card.subtitle })
        ] }, card.id || index)) })
      ]
    }
  );
};
var StatsGrid_default = StatsGrid;

// src/components/cards/Testimonials.tsx
import { motion as motion3 } from "motion/react";
import { Paper as Paper4, Typography as Typography15 } from "@wbk/ui";
import { StarIcon } from "@wbk/svg";
import { jsx as jsx18, jsxs as jsxs16 } from "react/jsx-runtime";
var starsContainerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.07, delayChildren: 0.2 } }
};
var ReviewCard = ({ card }) => /* @__PURE__ */ jsx18("div", { className: "w-[min(420px,82vw)] shrink-0 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsxs16(
  Paper4,
  {
    size: "L",
    surface: "level-1",
    className: "rounded-XL h-full text-start transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-xl",
    children: [
      !!card.rate && /* @__PURE__ */ jsx18(
        motion3.div,
        {
          initial: "hidden",
          animate: "visible",
          variants: starsContainerVariants,
          className: "flex items-center gap-1",
          children: Array.from({ length: card.rate }).map((_, star) => /* @__PURE__ */ jsx18(StarIcon, { className: "text-notice" }, star))
        }
      ),
      card.description && /* @__PURE__ */ jsx18(Typography15, { className: "mt-5", children: card.description }),
      /* @__PURE__ */ jsxs16("div", { className: "mt-5 flex items-center gap-3", children: [
        card.image && /* @__PURE__ */ jsx18(ContentfulMedia_default, { media: card.image, className: "h-8 w-8 rounded-full" }),
        /* @__PURE__ */ jsxs16("div", { children: [
          /* @__PURE__ */ jsx18(Typography15, { variant: "label-M", children: card.title }),
          card.subtitle && /* @__PURE__ */ jsx18(Typography15, { variant: "body-S", color: "text-secondary", children: card.subtitle })
        ] })
      ] })
    ]
  }
) });
var MIN_CARDS_PER_HALF = 8;
var BASE_DURATION_SECONDS = 60;
var Testimonials = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length)) return null;
  const halfRepeats = Math.max(1, Math.ceil(MIN_CARDS_PER_HALF / cards.length));
  const repeatedCards = Array.from({ length: halfRepeats * 2 }).flatMap(() => cards);
  return /* @__PURE__ */ jsxs16(
    DecoratedSection_default,
    {
      section,
      className: "container overflow-hidden text-center",
      "data-testid": `section_testimonials_${section.id}`,
      children: [
        /* @__PURE__ */ jsxs16("div", { className: "space-y-1", children: [
          section.title && /* @__PURE__ */ jsx18(Typography15, { as: "h2", variant: "display-S", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx18(Typography15, { variant: "body-S", color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsx18(
          "img",
          {
            src: "/@wbk/contentful/testimonials/testimonials-bg.png",
            alt: "",
            className: "relative mx-auto !-mt-12"
          }
        ),
        /* @__PURE__ */ jsx18("div", { className: "group overflow-hidden pt-8 [-webkit-mask-image:linear-gradient(90deg,transparent,hsl(var(--bg-body))_8%,hsl(var(--bg-body))_92%,transparent)] [mask-image:linear-gradient(90deg,transparent,hsl(var(--bg-body))_8%,hsl(var(--bg-body))_92%,transparent)]", children: /* @__PURE__ */ jsx18(
          "div",
          {
            className: "ltr:animate-marquee-left rtl:animate-marquee-right flex w-max group-hover:[animation-play-state:paused]",
            style: { animationDuration: `${BASE_DURATION_SECONDS * halfRepeats}s` },
            children: repeatedCards.map((card, index) => /* @__PURE__ */ jsx18(ReviewCard, { card }, `${card.id || "card"}-${index}`))
          }
        ) })
      ]
    }
  );
};
var Testimonials_default = Testimonials;

// src/components/cards/TicketPricingCards.tsx
import { useGetTickets } from "@wbk/api/hooks";
import { Button as Button7, Typography as Typography16 } from "@wbk/ui";
import { Link as Link10, useRouter as useRouter4, useTranslation as useTranslation4 } from "@wbk/config";
import { CurrencyPriceLabel } from "@wbk/currency";
import { jsx as jsx19, jsxs as jsxs17 } from "react/jsx-runtime";
var TicketPricingCards = ({ section }) => {
  var _a, _b, _c, _d;
  const { locale } = useRouter4();
  const { t } = useTranslation4(["contentful_common"]);
  const eventSlug = section.teamId;
  const { data, isLoading, error } = useGetTickets(
    {
      lang: locale,
      slug: eventSlug || "",
      ticketType: "event",
      perPage: 50
    },
    { enabled: !!eventSlug }
  );
  const tickets = (data == null ? void 0 : data.tickets) || [];
  const fee = (Number((_b = (_a = data == null ? void 0 : data.event) == null ? void 0 : _a.fees) == null ? void 0 : _b.amount) || 0) + (Number((_d = (_c = data == null ? void 0 : data.event) == null ? void 0 : _c.fees) == null ? void 0 : _d.vat) || 0);
  const bookingPath = `/${locale}/events/${eventSlug}/book`;
  if (!eventSlug || error) return null;
  return /* @__PURE__ */ jsxs17(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_ticket_pricing_cards_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsx19(Typography16, { as: "h2", variant: "heading-L", children: section.title }),
        /* @__PURE__ */ jsx19("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4", children: isLoading ? Array.from({ length: 4 }, (_, i) => /* @__PURE__ */ jsx19("div", { className: "bg-paper-level-2 h-64 animate-pulse" }, i)) : tickets.map((ticket) => {
          var _a2;
          const price = ((_a2 = ticket.deal) == null ? void 0 : _a2.deal_price) || Number(ticket.price) + Number(ticket.vat) + fee;
          const originalPrice = Number(ticket.original_price) + Number(ticket.original_price_vat) + fee;
          const search = new URLSearchParams({ ticket_id: ticket._id });
          if (ticket.seats_io_category) {
            search.set("seats_io_category", ticket.seats_io_category);
          }
          return /* @__PURE__ */ jsxs17(
            Link10,
            {
              to: `${bookingPath}?${search.toString()}`,
              className: "bg-body hover:bg-primary hover:text-primary-contrast group flex flex-col justify-between gap-y-16 p-6 transition-colors duration-200",
              children: [
                /* @__PURE__ */ jsx19(Typography16, { variant: "heading-XL", strong: true, children: ticket.title }),
                /* @__PURE__ */ jsxs17("div", { children: [
                  /* @__PURE__ */ jsx19(
                    CurrencyPriceLabel,
                    {
                      originalPrice,
                      discountPrice: price,
                      currency: ticket.currency,
                      zeroAsFree: true,
                      priceClassName: "text-display-M !font-black",
                      currencyClassName: "w-10 h-10",
                      className: "leading-none"
                    }
                  ),
                  Number(ticket.original_price || 0) > 0 && /* @__PURE__ */ jsx19(
                    Typography16,
                    {
                      variant: "label-XS",
                      color: "text-secondary",
                      className: "group-hover:text-primary-contrast",
                      children: t("contentful_common:inc_tax_and_fees")
                    }
                  ),
                  /* @__PURE__ */ jsx19(
                    Button7,
                    {
                      as: "div",
                      className: "group-hover:bg-action group-hover:text-action-contrast mt-4 w-full",
                      theme: "primary",
                      children: t("contentful_common:book_now")
                    }
                  )
                ] })
              ]
            },
            ticket._id
          );
        }) })
      ]
    }
  );
};
var TicketPricingCards_default = TicketPricingCards;

// src/components/cards/TimelineCarousel.tsx
import { Carousel as Carousel3, Typography as Typography17 } from "@wbk/ui";
import { CheckIcon } from "@wbk/svg";
import { twMerge as twMerge6 } from "tailwind-merge";
import { Fragment as Fragment7, jsx as jsx20, jsxs as jsxs18 } from "react/jsx-runtime";
var TimelineCarousel = ({ section }) => {
  const cards = section.contentCollection.items;
  if (!(cards == null ? void 0 : cards.length)) return null;
  return /* @__PURE__ */ jsx20(DecoratedSection_default, { section, className: "container", children: /* @__PURE__ */ jsx20(
    Carousel3,
    {
      options: { dragFree: true },
      title: /* @__PURE__ */ jsxs18(Fragment7, { children: [
        section.title && /* @__PURE__ */ jsx20(Typography17, { as: "h2", variant: "heading-L", children: section.title }),
        section.subtitle && /* @__PURE__ */ jsx20(Typography17, { color: "text-secondary", className: "mt-1", children: section.subtitle })
      ] }),
      children: cards.map((card, index) => {
        const isActive = !!card.isNew;
        const isEven = index % 2 === 0;
        return /* @__PURE__ */ jsxs18("div", { className: "relative flex min-w-64 flex-col items-center", children: [
          /* @__PURE__ */ jsx20("div", { className: "bg-text-tertiary absolute left-0 right-0 top-1/2 z-0 h-px -translate-y-1/2" }),
          /* @__PURE__ */ jsx20(
            "div",
            {
              className: twMerge6(
                "bg-body absolute left-1/2 top-1/2 z-10 flex h-8 w-8 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full",
                isActive && "bg-primary",
                !isActive && "border-text-secondary border-4"
              ),
              children: isActive && /* @__PURE__ */ jsx20(CheckIcon, { className: "text-primary [&_rect]:fill-primary h-8 w-8 [&_path]:fill-white" })
            }
          ),
          /* @__PURE__ */ jsxs18("div", { className: twMerge6("flex w-full", isEven ? "flex-col" : "flex-col-reverse"), children: [
            card.title && /* @__PURE__ */ jsx20(
              "div",
              {
                className: twMerge6(
                  "flex items-center justify-center text-center",
                  isEven ? "mt-32" : "mb-32"
                ),
                children: /* @__PURE__ */ jsxs18("div", { className: "space-y-1", children: [
                  /* @__PURE__ */ jsx20(Typography17, { variant: "heading-S", title: card.title, children: card.title }),
                  card.subtitle && /* @__PURE__ */ jsx20(
                    Typography17,
                    {
                      variant: "body-S",
                      color: "text-secondary",
                      title: card.subtitle,
                      style: { color: card.color },
                      children: card.subtitle
                    }
                  )
                ] })
              }
            ),
            card.image11 && /* @__PURE__ */ jsx20(
              "div",
              {
                className: twMerge6(
                  "flex items-center justify-center",
                  isEven ? "mt-32" : "mb-32"
                ),
                children: /* @__PURE__ */ jsx20(
                  ContentfulMedia_default,
                  {
                    media: card.image11,
                    width: 180,
                    height: 180,
                    className: `aspect-1 rounded-lg ${!isActive ? "opacity-40 grayscale" : ""}`
                  }
                )
              }
            ),
            !card.image11 && !card.title && card.subtitle && /* @__PURE__ */ jsx20("div", { className: "flex flex-col items-center justify-center py-12", children: /* @__PURE__ */ jsx20(Typography17, { variant: "heading-S", color: "text-secondary", children: card.subtitle }) })
          ] })
        ] }, card.sys.id);
      })
    }
  ) });
};
var TimelineCarousel_default = TimelineCarousel;

export {
  Announcement_default,
  BenefitsTable_default,
  CardsCarousel_default,
  CardsCarouselMini_default,
  CardsGrid_default,
  CardsInfoCarousel_default,
  SquareGrid_default,
  FAQsCards_default,
  ImageInfoCarousel_default,
  InstagramCardsCarousel_default,
  LinkCards_default,
  PerksGrid_default,
  SocialCardsSection_default,
  SocialCardsAsync_default,
  StandingsTable_default,
  StatsGrid_default,
  Testimonials_default,
  TicketPricingCards_default,
  TimelineCarousel_default
};
//# sourceMappingURL=chunk-TXVEZWBR.mjs.map